import { DraggableList, Icon, IconButton, Stack, Tooltip, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { CompilationModel, useUpdateCompilationSorting } from "@tm/data/compilations"
import { useCallback } from "react"
import { CompilationsListItem } from "./CompilationsListItem"
import { useFavoriteArticlesStore } from "../../store"

type Props = {
    compilations: CompilationModel[]
    onOpenCompilationDetails(id: string): void
    openCompilationList(): void
    query?: string
}

export function CompactCompilationsList({ compilations, onOpenCompilationDetails, openCompilationList, query }: Props) {
    const { translateText } = useLocalization()
    const { selectedCompilation } = useFavoriteArticlesStore()
    const { setCompilationToEdit } = useFavoriteArticlesStore()

    const handleButtonClick = useCallback(() => {
        setCompilationToEdit({ name: "", type: "add" })
    }, [])

    const { updateCompilationSorting } = useUpdateCompilationSorting(query)

    function handleReorder(from: string, to: string) {
        updateCompilationSorting({ fromCompilationId: from, toCompilationId: to })
    }

    return (
        <>
            <Stack direction="row" justifyContent="space-between" alignItems="center" pb={1}>
                <Typography variant="h3">{translateText(12791)}</Typography>
                <Stack direction="row" gap={0.5}>
                    <Tooltip title={translateText(13946)}>
                        <IconButton onClick={handleButtonClick} size="large" variant="contained">
                            <Icon name="plus" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={translateText(6)}>
                        <IconButton onClick={openCompilationList} size="large" variant="contained" color="highlight">
                            <Icon name="arrow-right" />
                        </IconButton>
                    </Tooltip>
                </Stack>
            </Stack>
            <DraggableList items={compilations.map((x) => x.id)} onReorder={handleReorder} sx={{ overflow: "auto", pr: 0.5, pl: 1, ml: -1 }}>
                {compilations.map((compilation) => (
                    <CompilationsListItem
                        key={compilation.id}
                        compilation={compilation}
                        isActive={selectedCompilation === compilation}
                        onOpenCompilationDetails={onOpenCompilationDetails}
                    />
                ))}
            </DraggableList>
        </>
    )
}
